<template>
  <div class="container" style="padding-top:40px" v-loading="loadings">
    <div class="formUs" style="width:830px;margin:0 auto">
      <table
        width="850"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
        style="border:1px solid #cccccc;"
      >
        <tr>
          <td width="170" rowspan="4" align="center">
            <!--证件照片<br />(170x210)-->
            <el-upload
              style="width:170px;height:210px"
              :action="action"
              :show-file-list="false"
              :data="uploadData"
                :on-change="(res)=>imgPreview(res)"
              :on-success="handleLogoSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                style="width:170px;height:210px"
                v-if="editForm.photo"
                :src="photo"
                fit="contain"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </td>
          <td width="130" align="center">申请人姓名</td>
          <td>
            <el-input v-model="editForm.real_name"></el-input>
          </td>
          <td width="130" align="center">性别</td>
          <td width="200">
            <div style="padding-left:10px">
              <el-radio v-model="editForm.sex" label="1">男</el-radio>
              <el-radio v-model="editForm.sex" label="2">女</el-radio>
            </div>
          </td>
        </tr>
        <tr>
          <td height="50" align="center">学历</td>
          <td>
            <el-select v-model="editForm.academic_certificate_type" placeholder="请选择">
              <el-option value="1" label="高中"></el-option>
              <el-option value="2" label="本科">本科</el-option>
              <el-option value="3" label="研究生">研究生</el-option>
              <el-option value="4" label="其他">其他</el-option>
            </el-select>
          </td>
          <td align="center">专业</td>
          <td>
            <el-input v-model="editForm.professional"></el-input>
          </td>
        </tr>
        <tr>
          <td height="50" align="center">毕业院校</td>
          <td>
            <el-input v-model="editForm.school"></el-input>
          </td>
          <td align="center">技术职称</td>
          <td>
            <el-input v-model="editForm.technical_title"></el-input>
          </td>
        </tr>
        <tr>
          <td height="50" align="center">身份证号码</td>
          <td align="left">
            <el-input maxlength="18" v-model="editForm.identity_card"></el-input>
          </td>
          <td align="center">邮箱</td>
          <td>
            <el-input v-model="editForm.email"></el-input>
          </td>
        </tr>
        <tr>
          <td width="170" height="50" align="center">检测站</td>
          <td colspan="4">
            <el-select
              v-model="editForm.station_id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td align="center">手机</td>
          <td colspan="4">
            <el-input maxlength="11" v-model="editForm.mobile"></el-input>
          </td>
        </tr>
      </table>
      <table
        width="850"
        border="0"
        align="center"
        cellpadding="0"
        cellspacing="0"
        style="border:1px solid #cccccc; border-top:none;"
      >
        <tbody>
          <tr>
            <td width="85" align="center" style="border-right:1px solid #cccccc; ">
              报
              <br />考
              <br />岗
              <br />位
            </td>
            <td width="84" align="center" style="border-right:1px solid #cccccc; ">
              <span v-if="editForm.sign_up_type==1">新训</span>
              <span v-else-if="editForm.sign_up_type==2">换证</span>
              <span v-else-if="editForm.sign_up_type==3">补考</span>
              <span v-else-if="editForm.sign_up_type==4">增岗</span>
            </td>
            <td width="676">
              <el-checkbox-group v-model="editForm.duties">
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr
                      style="border-bottom:1px solid #cccccc;"
                      v-for="item in duty_idArr"
                      :key="item.id"
                    >
                      <td
                        width="15%"
                        align="center"
                        style="border-right:1px solid #cccccc; border-bottom:1px solid #cccccc;font-size:14px"
                      >
                        <p>{{item.name}}</p>
                      </td>
                      <td width="80%" style="border-bottom:1px solid #cccccc;">
                        <div class="fxk" style="padding:10px">
                          <el-checkbox
                            v-for="check in item.children"
                            :key="check.id"
                            :label="check.id"
                          >{{check.name}}</el-checkbox>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-checkbox-group>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="padding:30px 0 20px 0; text-align:center;">
        <el-button @click="phonealid">提交申请表</el-button>
      </div>
    </div>
    <el-dialog width="300px" :visible.sync="showdialog">
      <el-input v-model="editForm.code">
        <div slot="append">
          <span style="cursor:pointer" v-show="show" @click="getMobildCode">获取验证码</span>
          <span v-show="!show">{{count}} s</span>
        </div>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="msgUpload">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      duty_idArr: [],
      checkList: [],
      action: window.baseUrl + "/api/v1/upload",
      uploadData: { folder: "images" },
      loading: false,
      loadings: false,
      showdialog: false,
      options: [],
      timer: "",
      show: false,
      photo:"",

      count: 2,

      editForm: { 
        real_name: "",
        sex: "1",
        station_id: "",
        identity_card: "",
        email: "",
        school: "",
        professional: "",
        academic_certificate_type: "", //学历类型 1高中 2本科 3研究生 4其他
        duties: [],
        photo: "",
        technical_title: "",
        sign_up_type: "", //证1新训 2换证 3补考 4增岗
        code: "",
        mobile: "",
        identity_card_front: "",
      },
    };
  },
  created() {
    this.getALLList(0);
    this.editForm.sign_up_type = this.$route.query.id;
  },
  methods: {
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
       imgPreview(file, name) {
      console.log(file.raw);
      const thisVue = this;

      const reader = new FileReader(); // 创建读取文件对象
      reader.readAsDataURL(file.raw); // 发起异步请求，读取文件
      reader.onload = function() {
        // 文件读取完成后
        // 读取完成后，将结果赋值给img的src
        // console.log(reader)
        thisVue.photo = reader.result;
      };
    },
    handleLogoSuccess(res, file) {
      if (res.status == 200) {
        this.editForm = Object.assign({}, this.editForm, {
          photo: res.data.url,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    remoteMethod(query) {
      this.loading = true;
      this.$http({
        url: "api/v1/auth/stations",
        method: "get",
        params: { keyword: query },
      }).then((res) => {
        this.loading = false;
        if (res.status == 200) {
          this.options = res.data.stations;
        } else {
          this.$message.error(res.msg);
          this.options = [];
        }
      });
    },
    getALLList() {
      this.$http({
        url: "api/v1/duties/all",
        method: "get",
      }).then((res) => {
        if (res.status == 200) {
          this.duty_idArr = res.data.duties;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    phonealid() {
      if (!this.editForm.photo) {
        return this.$message.error("请上传证件照");
      }
      if (!this.editForm.real_name) {
        return this.$message.error("姓名不得为空");
      }
      if (!this.editForm.sex) {
        return this.$message.error("性别不得为空");
      }

      if (!this.editForm.identity_card) {
        return this.$message.error("身份证不得为空");
      }
     
       
      if (!this.editForm.academic_certificate_type) {
        return this.$message.error("学历类型不得为空");
      }
      if (!this.editForm.duties) {
        return this.$message.error("岗位不得为空");
      }
      // 邮箱选填、专业、毕业院校、技术职称选填，其余必填
      // if (!this.editForm.technical_title) {
      //   return this.$message.error("技术职称不得为空");
      // }
      if (!this.editForm.mobile) {
        return this.$message.error("手机号不得为空");
      }

      let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      if (!phoneReg.test(this.editForm.mobile)) {
        //引入methods中封装的检查手机格式的方法
        return this.$message.error("请输入正确的手机号!");
      }

      if (this.editForm.station_id.length == 0) {
        return this.$message.error("检测站不得为空");
      }
      this.loadings = true;
      this.$http({
        url: "api/v1/appointments",
        method: "get",
        params: { mobile: this.editForm.mobile },
      })
        .then((res) => {
          this.loadings = false;
          if (res.status == 200) {
            if (res.data.is_register >= 1) {
              // 已注册
              this.getMobildCode();
            } else {
              this.uploadMeg();
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loadings = false;
          if (err.response) {
            let data = err.response.data;
            if (data && data.errors) {
              let obj = data.errors;
              let errorMess = obj[Object.keys(obj)[0]];
              this.$message.error(errorMess[0]);
            } else {
              this.$message.error("系统错误,请联系管理员");
            }
          } else {
            this.$message.error("系统错误,请联系管理员");
          }
        });
    },
    msgUpload() {
      if (!this.editForm.code) {
        return this.$message.error("验证码不得为空");
      }
      this.uploadMeg();
    },
    uploadMeg() {
      this.showdialog = false;
      this.loadings = true;
      this.$http({
        url: "api/v1/appointments",
        method: "post",
        data: this.editForm,
      })
        .then((res) => {
          this.loadings = false;
          if (res.status == 200) {
            this.$message.success(res.msg);
            this.editForm = {
              photo: "",
              real_name: "",
              sex: "1",
              station_id: "",
              identity_card: "",
              email: "",
              school: "",
              professional: "",
              academic_certificate_type: "", //学历类型 1高中 2本科 3研究生 4其他
              duties: [],
              photo: "",
              technical_title: "",
              sign_up_type: this.$route.query.id, //证1新训 2换证 3补考 4增岗
              code: "",
              mobile: "",
              identity_card_front: "",
            };
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loadings = false;
          if (err.response) {
            let data = err.response.data;
            if (data && data.errors) {
              let obj = data.errors;
              let errorMess = obj[Object.keys(obj)[0]];
              this.$message.error(errorMess[0]);
            } else {
              this.$message.error("系统错误,请联系管理员");
            }
          } else {
            this.$message.error("系统错误,请联系管理员");
          }
        });
    },
    getMobildCode() {
      this.$http({
        url: "/api/v1/captcha/send",
        method: "post",
        data: { mobile: this.editForm.mobile, type: "10004" },
      })
        .then((res) => {
          this.showdialog = true;
          if (res.status == 200) {
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          if (err.response) {
            let data = err.response.data;
            if (data.errors) {
              if (data.errors.mobile) {
                this.$message.error(data.errors.mobile[0]);
              } else {
                this.$message.error(data.message);
              }
            }
            console.log(err.response);
          }
        });

      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style  lang="less">
.formUs {
  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .avatar-uploader-icon {
      font-size: 50px;
    }
  }
  .el-input__inner {
    height: 50px;
    border: none;
  }
  table {
    border-collapse: collapse;
  }
  td {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped>
input:focus {
  outline: none;
}
</style>